/**
 * FollowStarV2 Component
 * Heart toggle for following runners (Pencil `Wneix`)
 * Uses star icon from design, red when active
 */

interface FollowStarV2Props {
  isFollowed: boolean;
  onToggle: (e: React.MouseEvent) => void;
  size?: number;
}

export function FollowStarV2({ isFollowed, onToggle, size = 18 }: FollowStarV2Props) {
  return (
    <button
      className={`v2-follow-btn ${isFollowed ? 'v2-follow-btn--active' : ''}`}
      onClick={(e) => {
        e.stopPropagation();
        onToggle(e);
      }}
      title={isFollowed ? 'Unfollow runner' : 'Follow runner'}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill={isFollowed ? 'currentColor' : 'none'}
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
      </svg>
    </button>
  );
}
